import { RiveHomeView, RiveHomeProps } from './RiveHomeView';
import { useSessionTimeOfDay } from './sessionTimeOfDay';

type RiveHomeContainerProps = RiveHomeProps & {
  coordinates?: { lat: number; lng: number };
};

export const RiveHome = ({ coordinates, ...sceneProps }: RiveHomeContainerProps) => (
  <RiveHomeView timeOfDay={useSessionTimeOfDay(coordinates)} {...sceneProps} />
);

export default RiveHome;
